const DAYS_TO_DEACTIVATION = 14;

export const getDeactivationDate = ({ trialEndDate }: { trialEndDate: string }) => {
	const date = new Date(trialEndDate);
	date.setDate(date.getDate() + DAYS_TO_DEACTIVATION);
	return {
		dateString: date.toLocaleDateString(undefined, {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		}),
		date,
	};
};
